import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ClientReviewCss from "./ClientReview.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
export default function ClientReview() {
  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: false,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,

    horizantalSwiping: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  const [clientReviews, setClientReviews] = useState([]);

  useEffect(() => {
    RestClient.GetRequest(AppUrl.HomeClientReview).then((result) =>
      setClientReviews(result)
    );
  }, []);
  return (
    <>
      <Container
        className={`${ClientReviewCss.reviewContainer} my-5 text-white`}
        fluid={true}
      >
        <h1 className="serviceMainTitle text-center pt-4">Testimonial</h1>
        <div className={`${ClientReviewCss.bottom}`}></div>

        <Slider {...settings} style={{ height: "200px" }}>
          {clientReviews.map((clientReview, i) => {
            return (
              <Row className="d-flex justify-content-center">
                <Col lg={6} md={6} sm={12}>
                  <img
                    src={clientReview.client_img}
                    alt=""
                    className={`${ClientReviewCss.imgTestimonial}`}
                  />
                  <h4 className={`${ClientReviewCss.title} text-center`}>
                    {clientReview.client_title}
                  </h4>
                  <p className={`${ClientReviewCss.description} text-center`}>
                    {clientReview.client_description}
                  </p>
                </Col>
              </Row>
            );
          })}
        </Slider>
      </Container>
    </>
  );
}
